<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="项目名称:" clearable>
        <el-input v-model.trim="searchForm.projectName" maxlength="30" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="原合同编号:" prop="reOldContractNum">
        <el-input v-model.trim="searchForm.oldContractNum" maxlength="20" placeholder="请输入原合同编号" />
      </el-form-item>
      <el-form-item label="合同编号:" clearable>
        <el-input v-model.trim="searchForm.newContractNum" maxlength="20" placeholder="请输入合同编号" />
      </el-form-item>

      <el-form-item label="代理商名称:">
        <el-input v-model.trim="searchForm.orderUnitName" maxlength="30" placeholder="请输入代理商名称" />
      </el-form-item>
      <el-form-item label="商务:">
        <el-input v-model.trim="searchForm.assistantName" maxlength="20" placeholder="请输入商务名称" />
      </el-form-item>
      <el-form-item label="合同类型:">
        <el-select v-model="searchForm.contractType" placeholder="请选择合同类型">
          <el-option v-for="item in selectList" :key="item.value" :value="item.value" :label="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item label="外销:">
        <el-input v-model.trim="searchForm.salesPersonName" maxlength="20" placeholder="请输入外销名称" />
      </el-form-item>
      <el-form-item label="合同时间:">
        <div class="rj-flex" style="width:260px;">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="部门:">
        <el-input v-model.trim="searchForm.salesPersonDeptName" maxlength="20" placeholder="请输入部门名称" />
      </el-form-item>
      <el-form-item label="区域:">
        <el-input v-model.trim="searchForm.salesArea" maxlength="20" placeholder="请输入区域名称" />
      </el-form-item>
      <el-form-item label="退换货原因:">
        <el-select v-model="searchForm.reasonType" placeholder="请选择退还原因">
          <el-option v-for="item in reasonList" :key="item.value" :value="item.value" :label="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="searchCilck">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="projectName" label="项目名称" min-width="220" align="left">
          <template v-slot="{ row }">
            <el-button class="el-btn-text-left" type="text" @click="toDetail(row)">
              {{ row.projectName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="oldContractNum" label="原合同编号" align="left" width="150" />
        <el-table-column prop="newContractNum" label="合同编号" align="left" width="150" />
        <el-table-column prop="erpOrderNum" label="ERP订单号" align="left" width="150" />
        <el-table-column prop="contractType" label="合同类型" align="left" width="150" />
        <el-table-column prop="reasonType" label="退换货原因" align="left" width="150">
          <!-- D8：落库值（如“产品发运错误”）经 displayReasonType 映射后再展示 -->
          <template slot-scope="scope">
            {{ displayReasonType(scope.row.reasonType) }}
          </template>
        </el-table-column>
        <el-table-column prop="salesPersonDeptName" label="部门" align="left" width="150" />
        <el-table-column prop="salesArea" label="区域" align="left" width="150" />
        <el-table-column prop="assistantName" label="商务" align="left" width="90" />
        <el-table-column label="合同时间" align="left" width="150">
          <template slot-scope="scope">
            {{ scope.row.createdTime }}
          </template>
        </el-table-column>
        <el-table-column label="合同附件" align="left" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="checkFile(scope.row)">
              查看附件
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="合同附件" :visible.sync="contractVisible" width="800px">
      <contract-attachment v-if="contractVisible" :contract-id="num" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="contractVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="es6">
import { overseasExOrderTodolist } from '@/API';
import contractAttachment from '../../returnExchange/Chief/commom/internationalfileDialog.vue';
import { displayReasonType } from '@/constant';
export default {
  data () {
    return {
      searchForm: {
        projectName: '',
        oldContractNum: '',
        newContractNum: '',
        orderUnitName: '',
        assistantName: '',
        contractType: '',
        salesPersonName: '',
        startTime: '',
        endTime: '',
        salesPersonDeptName: '',
        salesArea: '', // 退换货原因
        reasonType: '',
        contractStatus: 4
      },
      contractVisible: false,
      tableLoading: false,
      num: '',
      tableData: [],
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      selectList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '换货合同',
          label: '换货合同'
        },
        {
          value: '价外费用合同',
          label: '价外费用合同'
        },
        {
          value: '退货合同(已发货)',
          label: '退货合同(已发货)'
        },
        {
          value: '退货合同(未发货)',
          label: '退货合同(未发货)'
        }
      ],
      reasonList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '市场销售原因',
          label: '市场销售原因'
        },
        {
          value: '产品缺货或停产',
          label: '产品缺货或停产'
        },
        {
          value: '其他特殊原因',
          label: '其他特殊原因'
        },
        {
          value: '其他特殊原因(税率)',
          label: '其他特殊原因(税率)'
        },
        {
          value: '齐套不提货撤单',
          label: '齐套不提货撤单'
        },
        {
          value: '产品功能问题',
          label: '产品功能问题'
        }
      ]
    };
  },
  components: {
    contractAttachment
  },
  computed: {

  },
  methods: {
    // D8：退换货原因展示名映射（落库值保持不变，仅展示层生效）
    displayReasonType,
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },

    searchCilck () {
      this.page.currentPage = 1;
      this.doSearch();
    },

    resetForm () {
      this.searchForm = {
        projectName: '',
        oldContractNum: '',
        newContractNum: '',
        orderUnitName: '',
        assistantName: '',
        contractType: '',
        salesPersonName: '',
        startTime: '',
        endTime: '',
        salesPersonDeptName: '',
        salesArea: '', // 退换货原因
        reasonType: '',
        contractStatus: 4
      };
      this.page.currentPage = 1;
      this.doSearch();
    },

    doSearch () {
      this.tableLoading = true;
      let parmas = {
        ...this.searchForm,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      overseasExOrderTodolist(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch(() => {

      });
      this.tableLoading = false;
    },
    toDetail (row) {
      this.$router.push({
        name: 'approvedInterOrderReturnExchange',
        query: {
          contractType: row.contractType,
          contractId: row.id
        }
      });
      console.log(row);
    },
    checkFile (row) {
      this.num = row.id;
      this.contractVisible = true;
    }
  },
  mounted () {
    this.doSearch();
  },
  activated () {

  },
  destroyed () {
  }
};
</script>
<style lang="scss"></style>
